export function linksBreadCrumb(routes, fatherPath, importType = null) {
  // const children = routes[0].children

  // if(!children.some(item => item.path.includes(fatherPath) )) {
  //   return []
  // }

  // let items = children.filter(child => child.path.includes(fatherPath))[0].children

  // if(items) {

  //   return items.reduce((acc, cur) => {
  //     if(importType != null && cur.name == 'import') {
  //       sessionStorage.setItem('importType',importType)
  //     }
  //     acc.push({ text: mountName(cur.name), to: `${fatherPath}/${cur.name}` })
  //     return acc
  //   }, [])
  // }
  return [
    { to: '/audience/import-contacts/choose-methods', text: 'audience.importContacts.breadCrumb.items.choose-method' },
    { to: '/audience/import-contacts/import' + (importType ? '/' + importType : ''), text: 'audience.importContacts.breadCrumb.items.import' },
    { to: '/audience/import-contacts/organize', text: 'audience.importContacts.breadCrumb.items.organize' },
    { to: '/audience/import-contacts/complete', text: 'audience.importContacts.breadCrumb.items.complete' },
  ]
}

export function mountName(str) {
  return str.replace(/[^\w ]/, ' ')
}

export function stateEnum(num) {
  const stateList = {
    1: 'success',
    2: 'info',
    3: 'warning',
    4: 'danger',
  }

  return stateList[num] || 'info'
}

export function typeEnum(num) {
  const typeList = {
    1: 'UMMAPED',
    2: 'MAPPED',
    3: 'IGNORE',
    4: 'NEW',
  }

  return typeList[num] || 'UMMAPED'
}
